import React, { Component } from 'react'
import './ButtonDark.css'

export default class ButtonDark extends Component {
    render() {
        return (
            <button {...this.props} className={"btn-tertium-dark "+this.props.className}>{ this.props.children }</button>
        )
    }
}